import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {Table} from "ant-design-vue";

import 'ant-design-vue/dist/antd.css'
import './assets/styles.css';
import './assets/element.css';
import router from "./router";
import moment from "moment";

Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Table);

new Vue({
    el: '#app',
    router,
    mounted() {
        this.$on('login', async () => {
            let redirect = this.$route.query.redirect;
            this.$router.push(redirect || '/app/home');
        });

        let token = this.$route.query.token;
        if (token) {
            localStorage.token = token;
        }
    }
});